class MessageListener {
    constructor(callback) {
        this.callback = callback;
        this.id = ++MessageListener.count;
    }
}

MessageListener.count = 0;

export default MessageListener;